// extracted by mini-css-extract-plugin
module.exports = {"landingCta":"LandingCta_landingCta__O7sZG","title":"LandingCta_title__4yAP3","rotation":"LandingCta_rotation__yPBJw","preventivoBoxBubble":"LandingCta_preventivoBoxBubble__ka1pJ"};